import React, { useEffect, useState } from "react";
import { X } from "lucide-react";

const statusOptions = [
  "IN_PROGRESS",
  "COMPLETED",
  "PENDING",
  "ON_HOLD",
  "CANCELLED",
];

const clientTypeOptions = [
  "RECURRING",
  "ONE_TIME",
];

export default function ClientListingFilter({
  isOpen,
  onClose,
  filters,
  setFilters,
  filterOptions = {
    categories: [],
    states: [],
    countries: [],
    users: [],
  },
  onApply,
  onReset,
}) {
  const [localFilters, setLocalFilters] = useState(filters);

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const updateField = (field, value) => {
    setLocalFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const toggleMultiSelect = (field, value) => {
    const current = localFilters[field] || [];

    if (current.includes(value)) {
      updateField(
        field,
        current.filter((item) => item !== value)
      );
    } else {
      updateField(field, [...current, value]);
    }
  };

  const applyFilters = () => {
    setFilters(localFilters);
    onApply();
  };

  const resetFilters = () => {
    const reset = {
      search: "",

      status: [],
      clientType: [],
      category: [],

      state: [],
      country: [],

      handleBy: [],
      createdBy: [],

      onboardingFrom: "",
      onboardingTo: "",

      createdFrom: "",
      createdTo: "",
    };

    setLocalFilters(reset);
    setFilters(reset);
    onReset();
  };

  if (!isOpen) return null;

  return (
    <>

      {/* Overlay */}

      <div
        onClick={onClose}
        className="fixed inset-0 bg-black/30 z-40"
      />

      {/* Sidebar */}

      <div className="fixed right-0 top-0 h-screen w-[420px] bg-white shadow-2xl z-50 flex flex-col">

        {/* Header */}

        <div className="flex items-center justify-between border-b px-6 py-5">

          <div>

            <h2 className="text-xl font-bold">
              Filters
            </h2>

            <p className="text-sm text-gray-500">
              Filter Client Listing
            </p>

          </div>

          <button
            onClick={onClose}
            className="p-2 rounded hover:bg-gray-100"
          >
            <X size={20} />
          </button>

        </div>

        {/* Body */}

        <div className="flex-1 overflow-y-auto p-6 space-y-6">
                      {/* Status */}

          <div>

            <label className="block text-sm font-semibold mb-3">
              Status
            </label>

            <div className="grid grid-cols-2 gap-2">

              {statusOptions.map((status) => (

                <label
                  key={status}
                  className="flex items-center gap-2 cursor-pointer"
                >

                  <input
                    type="checkbox"
                    checked={localFilters.status.includes(status)}
                    onChange={() =>
                      toggleMultiSelect("status", status)
                    }
                  />

                  <span className="text-sm">
                    {status.replaceAll("_", " ")}
                  </span>

                </label>

              ))}

            </div>

          </div>

          {/* Client Type */}

          <div>

            <label className="block text-sm font-semibold mb-3">
              Client Type
            </label>

            <div className="grid grid-cols-2 gap-2">

              {clientTypeOptions.map((type) => (

                <label
                  key={type}
                  className="flex items-center gap-2 cursor-pointer"
                >

                  <input
                    type="checkbox"
                    checked={localFilters.clientType.includes(type)}
                    onChange={() =>
                      toggleMultiSelect("clientType", type)
                    }
                  />

                  <span className="text-sm">
                    {type.replaceAll("_", " ")}
                  </span>

                </label>

              ))}

            </div>

          </div>

          {/* Category */}

          <div>

            <label className="block text-sm font-semibold mb-3">
              Category
            </label>

            <div className="max-h-40 overflow-y-auto border rounded-lg p-3 space-y-2">

              {filterOptions.categories.length > 0 ? (

                filterOptions.categories.map((category) => (

                  <label
                    key={category}
                    className="flex items-center gap-2 cursor-pointer"
                  >

                    <input
                      type="checkbox"
                      checked={localFilters.category.includes(category)}
                      onChange={() =>
                        toggleMultiSelect("category", category)
                      }
                    />

                    <span className="text-sm">
                      {category}
                    </span>

                  </label>

                ))

              ) : (

                <p className="text-sm text-gray-400">
                  No Categories
                </p>

              )}

            </div>

          </div>

          {/* State */}

          <div>

            <label className="block text-sm font-semibold mb-3">
              State
            </label>

            <div className="max-h-40 overflow-y-auto border rounded-lg p-3 space-y-2">

              {filterOptions.states.length > 0 ? (

                filterOptions.states.map((state) => (

                  <label
                    key={state}
                    className="flex items-center gap-2 cursor-pointer"
                  >

                    <input
                      type="checkbox"
                      checked={localFilters.state.includes(state)}
                      onChange={() =>
                        toggleMultiSelect("state", state)
                      }
                    />

                    <span className="text-sm">
                      {state}
                    </span>

                  </label>

                ))

              ) : (

                <p className="text-sm text-gray-400">
                  No States
                </p>

              )}

            </div>

          </div>

          {/* Country */}

          <div>

            <label className="block text-sm font-semibold mb-3">
              Country
            </label>

            <div className="max-h-40 overflow-y-auto border rounded-lg p-3 space-y-2">

              {filterOptions.countries.length > 0 ? (

                filterOptions.countries.map((country) => (

                  <label
                    key={country}
                    className="flex items-center gap-2 cursor-pointer"
                  >

                    <input
                      type="checkbox"
                      checked={localFilters.country.includes(country)}
                      onChange={() =>
                        toggleMultiSelect("country", country)
                      }
                    />

                    <span className="text-sm">
                      {country}
                    </span>

                  </label>

                ))

              ) : (

                <p className="text-sm text-gray-400">
                  No Countries
                </p>

              )}

            </div>

          </div>
                    {/* Handle By */}

          <div>
            <label className="block text-sm font-semibold mb-3">
              Handle By
            </label>

            <div className="max-h-40 overflow-y-auto border rounded-lg p-3 space-y-2">

              {filterOptions.users.length > 0 ? (

                filterOptions.users.map((user) => {

                  const name = `${user.firstName} ${user.lastName}`;

                  return (
                    <label
                      key={user._id}
                      className="flex items-center gap-2 cursor-pointer"
                    >
                      <input
                        type="checkbox"
                        checked={localFilters.handleBy.includes(user._id)}
                        onChange={() =>
                          toggleMultiSelect("handleBy", user._id)
                        }
                      />

                      <span className="text-sm">
                        {name}
                      </span>
                    </label>
                  );
                })

              ) : (

                <p className="text-sm text-gray-400">
                  No Users
                </p>

              )}

            </div>
          </div>

          {/* Created By */}

          <div>
            <label className="block text-sm font-semibold mb-3">
              Created By
            </label>

            <div className="max-h-40 overflow-y-auto border rounded-lg p-3 space-y-2">

              {filterOptions.users.length > 0 ? (

                filterOptions.users.map((user) => {

                  const name = `${user.firstName} ${user.lastName}`;

                  return (
                    <label
                      key={user._id}
                      className="flex items-center gap-2 cursor-pointer"
                    >
                      <input
                        type="checkbox"
                        checked={localFilters.createdBy.includes(user._id)}
                        onChange={() =>
                          toggleMultiSelect("createdBy", user._id)
                        }
                      />

                      <span className="text-sm">
                        {name}
                      </span>
                    </label>
                  );
                })

              ) : (

                <p className="text-sm text-gray-400">
                  No Users
                </p>

              )}

            </div>
          </div>

          {/* Onboarding Date */}

          <div>

            <label className="block text-sm font-semibold mb-3">
              Onboarding Date
            </label>

            <div className="grid grid-cols-2 gap-3">

              <div>

                <label className="text-xs text-gray-500">
                  From
                </label>

                <input
                  type="date"
                  value={localFilters.onboardingFrom}
                  onChange={(e) =>
                    updateField(
                      "onboardingFrom",
                      e.target.value
                    )
                  }
                  className="w-full mt-1 border rounded-lg px-3 py-2"
                />

              </div>

              <div>

                <label className="text-xs text-gray-500">
                  To
                </label>

                <input
                  type="date"
                  value={localFilters.onboardingTo}
                  onChange={(e) =>
                    updateField(
                      "onboardingTo",
                      e.target.value
                    )
                  }
                  className="w-full mt-1 border rounded-lg px-3 py-2"
                />

              </div>

            </div>

          </div>

          {/* Created Date */}

          <div>

            <label className="block text-sm font-semibold mb-3">
              Created Date
            </label>

            <div className="grid grid-cols-2 gap-3">

              <div>

                <label className="text-xs text-gray-500">
                  From
                </label>

                <input
                  type="date"
                  value={localFilters.createdFrom}
                  onChange={(e) =>
                    updateField(
                      "createdFrom",
                      e.target.value
                    )
                  }
                  className="w-full mt-1 border rounded-lg px-3 py-2"
                />

              </div>

              <div>

                <label className="text-xs text-gray-500">
                  To
                </label>

                <input
                  type="date"
                  value={localFilters.createdTo}
                  onChange={(e) =>
                    updateField(
                      "createdTo",
                      e.target.value
                    )
                  }
                  className="w-full mt-1 border rounded-lg px-3 py-2"
                />

              </div>

            </div>

          </div>

        </div>

        {/* Footer */}

        <div className="border-t p-5 flex gap-3">

          <button
            onClick={resetFilters}
            className="flex-1 border border-gray-300 rounded-lg py-3 font-medium hover:bg-gray-100"
          >
            Reset
          </button>

          <button
            onClick={applyFilters}
            className="flex-1 bg-red-600 text-white rounded-lg py-3 font-medium hover:bg-red-700"
          >
            Apply Filters
          </button>

        </div>

      </div>

    </>
  );

}